/**
 * @desc 后台分页查询资金流水
 */
import {
  PageJournalEntity,
  JournalOperationPageQuery
} from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryJournalPageParameter = JournalOperationPageQuery

const method = 'GET'
const url = '/finance/operation/journal/page'

export const queryJournalPageApi = (
  params?: QueryJournalPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageJournalEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryJournalPageApi.method = method
queryJournalPageApi.url = url
